/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line import/no-extraneous-dependencies
import '@fontsource/poppins';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import * as React from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import ButtonAction from '@src/components/buttons/action.button';
import LabTabs from '@src/components/commons/tabs.common';

import AppUserActivities from './appUserActivities';
import AppUserVerified from './appUserVerified';
import BadgeCustomization from './badgeCustomization';
import CLAProfile from './claProfile';
import UserSettings from './userSettings';

export default function VerifiedCLAInformation() {
  const path = useLocation().pathname;
  const { state } = useLocation();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(state?.prevLocation || -1);
  };

  const menuAppUsers = [
    {
      idx: 0,
      title: 'Verification Information',
      component: (
        <div>
          <AppUserVerified />
        </div>
      ),
    },
    {
      idx: 1,
      title: 'Profile',
      component: (
        <div>
          <CLAProfile />
        </div>
      ),
    },
    {
      idx: 2,
      title: 'Booking Activities',
      component: (
        <div>
          <AppUserActivities />
        </div>
      ),
    },
    {
      idx: 3,
      title: 'Badges',
      component: (
        <div>
          <BadgeCustomization />
        </div>
      ),
    },

    {
      idx: 4,
      title: 'Settings',
      component: (
        <div>
          <UserSettings />
        </div>
      ),
    },
  ];

  return (
    <Box
      sx={{ width: '100%', margin: 4, fontFamily: 'Poppins' }}
      pathUrl={path}
      actionRight={<ButtonAction label='Create account for users' />}
    >
      <Button
        sx={{
          textTransform: 'none',
          paddingLeft: 0,
        }}
        className='py-4 font-bold text-purple-500'
        variant='text'
        // eslint-disable-next-line react/jsx-no-bind
        onClick={handleBack}
      >
        Back
      </Button>
      <LabTabs menus={menuAppUsers} />
    </Box>
  );
}
